module.exports = __webpack_public_path__ + "static/media/15.02.98242140.jpg";